import React from 'react';
import { Bundle } from '@ali/visualengine';
import {
  getDataSetterSnippet,
} from '@/common/manager/setter-snippet';
import { dataOriginRequest } from '@/common/util/const';
import { createEventSetters } from '@/common/manager/event';
import { ButtonPosition } from '@/type/button-position';

// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype
export default Bundle.createPrototype({
  title: '快捷入口',
  componentName: 'CnEntryPoints',
  category: '快捷入口',
  isContainer: false,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/imgextra/i3/O1CN01c0tKGI1hnWehseVGK_!!6000000004322-0-tps-708-1034.jpg',
      label: 'CnEntryPoints',
      schema: {
        componentName: 'CnEntryPoints',
        props: {},
      },
    },
  ],
  configure: [
    {
      name: 'isCnEntryPoints',
      title: 'isCnEntryPoints',
      initialValue: true,
      display: 'none',
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    {
      title: '样式',
      type: 'group',
      display: 'accordion',
      collapsed: false,
      items: [
        {
          name: 'title',
          title: '一级标题',
          display: 'inline',
          setter: 'StringSetter',
          defaultValue: '一级标题',
        },
        {
          name: 'icon',
          title: '图标',
          display: 'inline',
          setter: 'StringSetter',
          defaultValue: 'like1'
        },
      ],
    },
    ...getDataSetterSnippet(),
    ...createEventSetters({
      position: ButtonPosition.entryPointsItemClick,
      initialValue: {
        optType: 'link',
      },
      title: '配置点击的的回调',
    }),
  ],
});
